<template>
    <div>
        <b-modal @hide="close" size="lg" ref="edit-flag-modal" id="edit-flag-modal">
            <template v-slot:modal-header>
                <span class="h3" v-if="order">Order #: {{ order.id }}</span>
                <b-button :href="'/kit/view/'+order.id" v-if="order && $route.name != 'kit-view-index'"
                          variant="success">View Kit <i class="fa-solid fa-arrow-circle-right"
                ></i>
                </b-button>
            </template>
            <template v-if="flag">
                <!-- flag type -->

                <b-form-group
                    :title="flag.flag_type.description"
                    label="Flag:"
                    label-for="flag-type-select">
                    <h5 v-if="loading"><i class="fa-regular fa-spin fa-spinner"></i></h5>
                    <h5 v-else>{{ flag.flag_type.name }}</h5>
                </b-form-group>

                <!-- notes -->
                <b-form-group
                    label="Notes:"
                    label-for="flag-notes">
                    <b-form-textarea
                        :disabled="flag.creator.id != $store.getters.getProfile.id"
                        placeholder="Add note"
                        v-model.lazy="flag.note"
                        id="replies"
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                </b-form-group>

                <!-- requester -->
                <b-form-group
                    label="Requester:"
                    label-for="requester">
                    <b-form-input :disabled="true" id="requester" v-model="flag.creator.name"></b-form-input>
                </b-form-group>

                <!-- deletor -->
                <b-form-group v-if="isCleared"
                        label="Cleared by:"
                        label-for="requester">
                    <b-form-input :disabled="true" id="requester" v-model="flag.deletor.name"></b-form-input>
                </b-form-group>

                <!-- recipient -->
                    <b-form-group label="Recipients:" label-for="tags-with-dropdown">
                        <b-form-tags id="tags-with-dropdown" no-outer-focus class="mb-2">
                            <template v-slot="{ tags, disabled }">
                                <ul v-if="flag.users && flag.users.length > 0" class="list-inline d-inline-block mb-2">
                                    <li v-for="user in flag.users" class="list-inline-item"
                                        @click="removeTag(user)">
                                        <b-form-tag
                                                :title="user.email"
                                                :disabled="disabled"
                                                variant="info"
                                        >{{ user.name }}</b-form-tag>
                                    </li>
                                </ul>
                                <loading-spinner :busy="flag.users == null"></loading-spinner>

                                <b-dropdown size="sm" variant="outline-secondary" block menu-class="w-100" :active="true" :disabled="flag.users == null">
                                    <b-dropdown-form @submit.stop.prevent="() => {}">
                                        <b-form-group
                                                label="Search tags"
                                                label-for="tag-search-input"
                                                label-cols-md="auto"
                                                class="mb-0"
                                                label-size="sm">
                                            <b-form-input
                                                    v-model="search"
                                                    id="tag-search-input"
                                                    type="search"
                                                    size="sm"
                                                    autocomplete="off"
                                            ></b-form-input>
                                        </b-form-group>
                                    </b-dropdown-form>
                                    <b-dropdown-divider></b-dropdown-divider>
                                    <b-row class="no-gutters">
                                        <b-col cols="6" class="set-height">
                                            <b-dropdown-item-button
                                                    v-for="option in _displayUsers"
                                                    @click.native.capture.stop="addUser(option)">
                                                {{ option.name }}
                                            </b-dropdown-item-button>
                                            <b-dropdown-text v-if="loading">
                                                Loading....
                                            </b-dropdown-text>
                                        </b-col>
                                        <b-col cols="6" class="set-height">
                                            <b-dropdown-item-button
                                                    v-for="option in _displayGroup"
                                                    @click.native.capture.stop="addGroup(option)">
                                                {{ option.name }}
                                            </b-dropdown-item-button>
                                            <b-dropdown-text v-if="loading">
                                                Loading....
                                            </b-dropdown-text>
                                        </b-col>
                                    </b-row>
                                </b-dropdown>
                            </template>
                        </b-form-tags>
                    </b-form-group>

                <!-- stop workflow/priority -->
                <div class="d-flex">
                    <b-form-checkbox class="mr-5" name="check-button" switch v-model="flag.stop_workflow">
                        <strong>Stop Workflow</strong>
                    </b-form-checkbox>

                    <b-form-checkbox name="check-button" switch v-model="flag.priority">
                        <strong>Priority</strong>
                    </b-form-checkbox>
                </div>

                <!-- date/time picker -->
                <div class="my-3">
                    <b-row>
                        <!--<label class="d-block mb-0" for="date-picker">Follow Up Date/Time:</label>
                        <datetime id="date-picker" v-model="flag.follow_up"
                                  class="d-inline-block"
                                  value-zone="America/New_York"
                                  :use12-hour="true"
                                  :minute-step="15"
                                  type="datetime">
                        </datetime> -->
                        <b-col cols="4">
                            <b-form-group label="Follow Up Date/Time:" label-class="font-weight-bold" style="max-height:60px;">
                                <!-- <DateRangePicker style="width:85%"
                                                 ref="dt_picker"
                                                 v-model="flag.follow_up_function"
                                                 :time-picker="true"
                                                 :show-ranges="false"
                                                 :single-date-picker="'single'"
                                                 :timePicker24Hour="false"
                                >
                                    <template v-slot:input="picker">
                                        <div class="text-center" style="width:100%; max-height:30px">
                                            {{ flag.follow_up_function.startDate | datetime }}{{ flag.follow_up_function.startDate ? '': 'mm-dd-yyyy mm:ss' }}
                                        </div>
                                    </template>
                                </DateRangePicker> -->
                                <vc-date-picker mode="dateTime" v-model="flag.follow_up" :minute-increment="5" :popover="datePickerProps"
                                :attributes="todaysDot" :timezone="'America/New_York'" :min-date="new Date()" :disabled-dates='{ weekdays: [1, 7] }'>
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <div v-on:click="" v-on="inputEvents" style="width:200px">
                                            <div class="text-center form-control d-inline" style="width:170px!important; max-height:30px">
                                                {{ flag.follow_up | datetime }}{{ flag.follow_up ? '': 'mm-dd-yyyy mm:ss' }}

                                            </div>
                                            <i v-on:click="clearDate()" style="top: 5px; font-size:31px" class="pointer position-relative fa-solid fa-window-close text-danger"></i>
                                        </div>
                                    </template>
                                </vc-date-picker>
                            </b-form-group>
                        </b-col>
                        <b-col cols="4" v-if="isCleared">
                            <b-form-group label="Cleared At Date/Time:" label-class="font-weight-bold" style="max-height:60px;">
                                <div class="pt-1">
                                    <b-input :disabled="true" class="text-center" style="width:100%; max-height:30px" v-model="_clearedDate">
                                    </b-input>
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="4">
                            <b-form-group label="Created At Date/Time:" label-class="font-weight-bold" style="max-height:60px;">
                                <div class="pt-1">
                                    <b-input :disabled="true" class="text-center" style="width:100%; max-height:30px" v-model="_createdDate">
                                    </b-input>
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>

                <!-- flag reply -->

                <b-table small :busy="flag.replies == null" :items="flag.replies" :fields="[{key: 'contents', label: 'Replies'}, 'creator_name', 'created_at']">
                    <!-- created at -->
                    <template v-slot:cell(created_at)="data">
                        <div>{{ data.value | datetime }}</div>
                    </template>

                    <template v-slot:table-busy>
                        <LoadingSpinner :busy="flag.replies == null"/>
                    </template>
                </b-table>

                <b-form-group v-if="!isCleared"
                    label="Replies:"
                    label-for="replies">
                    <b-form-textarea
                        id="replies"
                        placeholder="Reply to flag..."
                        rows="3"
                        max-rows="6"
                        v-model="reply_text"
                    ></b-form-textarea>
                </b-form-group>
            </template>


            <template v-slot:modal-footer>
                <div class="w-100">
                    <i class="fa-regular fa-spin fa-spinner mr-4" v-if="!canUpdate"></i>
                    <i class="fa-regular fa-spin fa-spinner mr-4" v-if="!canUpdate"></i>
                    <i class="fa-regular fa-spin fa-spinner mr-4" v-if="!canUpdate"></i>
                    <b-button v-if="!isCleared && canUpdate" @click="reply" variant="primary" class="float-left" :disabled="!!isSaving"><i class="fa-regular fa-spinner fa-spin mr-2" v-if="isSaving == 'reply'"></i>Reply</b-button>
                    <b-button v-if="!isCleared && canClearFlag && canUpdate" @click="replyAndClear" variant="warning" class="float-left ml-2" :disabled="!!isSaving"><i class="fa-regular fa-spinner fa-spin mr-2" v-if="isSaving == 'replyClose'"></i>Reply and Clear
                    </b-button>
                    <b-button v-if="!isCleared && canUpdate" @click="save" variant="primary" class="float-right" :disabled="!!isSaving"><i class="fa-regular fa-spinner fa-spin mr-2" v-if="isSaving == 'save'"></i>Update Flag</b-button>
                    <b-button v-if="!isCleared && canClearFlag && canUpdate" @click="clear" variant="warning" class="float-right mr-2" :disabled="!!isSaving"><i class="fa-regular fa-spinner fa-spin mr-2" v-if="isSaving == 'clear'"></i>Clear Flag</b-button>
                    <b-button @click="close" class="float-right mr-2">Cancel</b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {Datetime} from 'vue-datetime';
import _ from 'lodash';
import moment from 'moment-timezone';
import DateRangePicker from 'vue2-daterange-picker'
import {
    BROADCAST_CONNECTED,
    NOTIFICATION_ADD,
    NOTIFICATION_REMOVE,
    SYNC_USER,
} from '../store/actions';
import LoadingSpinner from "./LoadingSpinner";

export default {
    name: 'EditFlagModal',
    components: {LoadingSpinner, Datetime,DateRangePicker},
    props: ['FlagEditIsOpen'],
    data() {
        return {
            allFlagTypes: [],
            allUsers: [],
            allRoles: [],
            allDeleteRoles: [],
            allDeleteUsers: [],
            flagOptions: ['Follow Up', 'Loss Prevention', 'Quote', 'Repair Request', 'Returns Expedite',
                'Suspicious Activity', 'High-Value Pending Offer', 'Enhanced Verification', 'Diamond', 'Brand Packaging', 'Out For Estimate', 'PTA', 'PTA + Enhanced Verification', 'Payment - Return ACH'],
            flag: null,
            order: null,
            customer: null,
            isSaving: false,
            loading: true,
            reply_text: "",
            search: "",
            canClearFlag: false,
            datePickerProps: {
                placement: 'right',
            },
            todaysDot: [
                {
                    key: 'today',
                    dot: true,
                    content: 'blue',
                    dates: new Date(),
                }
            ]
        };
    },
    methods: {
        open() {
            var count = 0;
            this.loading = true;
            if(this.loading) {
                this.$store.dispatch(SYNC_USER, (e) => {
                    this.$store.dispatch('GET_REQUEST', '/flag-types?include=roles,users').then((e) => {
                        this.allFlagTypes = e.data.data;
                        console.log(this.allFlagTypes);
                        count++;
                        if (count == 3) {
                            this.checkFlagType();
                        }
                    });
                    this.$store.dispatch('GET_REQUEST', '/users').then((e) => {
                        this.allUsers = e.data.data;
                        count++;
                        if (count == 3) {
                            this.checkFlagType();
                        }
                    });
                    this.$store.dispatch('GET_REQUEST', '/roles').then((e) => {
                        this.allRoles = e.data.data;
                        count++;
                        if (count == 3) {
                            this.checkFlagType();
                        }
                    });
                });
            }
            //this.order = this.$store.getters.activeOrder;
            let flag = _.assign({},this.selectedFlag);
            if(flag.flaggable_type == 'GoldExchange\\Models\\Order') {
                this.order = {id:flag.flaggable_id};
            }
            //todo ui logic
            if(flag.flaggable_type == 'GoldExchange\\Models\\Customer') {
                this.customer = {id:flag.flaggable_id};
            }
            flag.replies = flag.replies || null;
            flag.users = flag.users ? _.assign([], flag.users): null;//fixes bug
            flag.follow_up = flag.follow_up ? new Date(flag.follow_up) : null;
            this.flag = flag;
            if(flag.users == null) {
                ///flags/{flag}/users
                this.$http.get('/flags/' + flag.id + '/users')
                .then((response) => {
                        this.flag.users = response.data.data;
                    }).catch((e)=> {
                        console.log("error",e);
                    });
            }
            if(flag.replies == null) {
                this.$http.get('/flags/' + flag.id + '/notes')
                    .then((response) => {
                        this.flag.replies = response.data.data;
                    }).catch((e)=> {
                        console.log("error",e);
                });
            }
            this.reply_text = "";
            this.$refs['edit-flag-modal'].show();
        },
        checkFlagType() {
            _.forEach(_.filter(this.allFlagTypes, (e) => {
                return e.id == this.flag.flag_type_id;
            }), (e) => {
                //this.allUsers = e.usersCanAssign.data;
                //this.allRoles = e.rolesCanAssign.data;
                this.allDeleteRoles = e.roles;
                this.allDeleteUsers = e.users;
                _.forEach(this.allRoles, (role) => {
                    _.forEach(role.users.data, (user) => {
                        if (_.filter(this.allUsers, (currUser) => {
                            return currUser.id == user.id;
                        }).length == 0) {
                            this.allUsers.push(user);
                        }
                    });
                });
                let decodedConfig = JSON.parse(e.config);
            });
            this.canClearFlag = this.canClearFlagFunc();
            this.loading = false;
            this.$forceUpdate();
        },
        reply() {
            if(!this.reply_text){
                this.$parent.$bvModal.msgBoxOk('Reply Text is required.', {
                    title: 'Invalid Input',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    headerClass: 'p-2 border-bottom-0 text-center d-block',
                    footerClass: 'p-2 border-top-0',
                });
                return;
            }
            this.isSaving = 'reply';
            let payload = {
                contents: this.reply_text,
            };
            this.$http.post('/flags/' + this.flag.id + '/notes', payload)
                .then((response) => {
                    this.flag.replies.push(response.data.data);
                    this.isSaving = false;
                    this.reply_text = null;
                    //this.$store.commit('commitFlag',this.flag);
                }).catch((e)=> {
                    this.isSaving = false;
                    console.log("error",e);
                });
        },
        replyAndClear() {
            if(!this.reply_text){
                this.$parent.$bvModal.msgBoxOk('Reply Text is required.', {
                    title: 'Invalid Input',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    headerClass: 'p-2 border-bottom-0 text-center d-block',
                    footerClass: 'p-2 border-top-0',
                });
                return;
            }
            this.isSaving = 'replyClose';
            let payload = {
                contents: this.reply_text,
                clear_flag: true,
            };
            this.$http.post('/flags/' + this.flag.id + '/notes', payload)
                .then((response) => {
                    this.flag.replies.push(response.data.data);
                    this.flag.cleared_at = new Date();
                    //this.$store.commit('commitFlag',this.flag);
                    this.close();
                }).catch((e)=> {
                    this.isSaving = false;
                    console.log("error",e);
                });
        },
        save() {
            this.isSaving = "save";
            let payload = {
                id: this.flag.id,
                flag_type_id: this.flag.flag_type.id,
                follow_up: this.flag.follow_up,
                note: this.flag.note,
                stop_workflow: this.flag.stop_workflow,
                priority: this.flag.priority,
                users: _.map(this.flag.users, function(e){return e.id;}),
            };
            this.$http.put('/flags/' + this.flag.id, payload)
            .then(response => {
                console.log(response);
                //this.$store.commit('commitFlag',response.data.data);
                this.close();
            });
        },
        clear() {
            this.isSaving = 'clear';
            let payload = {
                id: this.flag.id,
                cleared_at: new Date(),
            };
            this.$http.put('/flags/' + this.flag.id, payload)
                .then(response => {
                    console.log(response);
                    this.$store.commit('commitFlag',response.data.data);
                    this.close();
                }).catch((e)=> {
                    this.isSaving = false;
                });
        },
        close() {
            this.$refs['edit-flag-modal'].hide();
            this.$emit('closeFlagEdit');
            this.$store.commit('setActiveFlag', null);
            this.isSaving = false;
        },
        clearDate(event) {
            this.flag.follow_up = null;
            this.$forceUpdate();
        },
        formateTime(value){
            if (value) {
                return moment((value)).tz('America/New_York').format('MM/DD/YYYY hh:mm a')
            }
        },
        removeTag(user){
            let i = this.flag.users.indexOf(user);
            if(i != -1) {
                this.flag.users.splice(i,1);
            }
        },
        addUser(user){
            this.flag.users.push(user);
        },
        addGroup(option){
            _.forEach(_.filter(this.allUsers,(e)=>{
                return -1 == _.findIndex(this.flag.users,(z)=>{return z.id == e.id;})
                    &&
                    -1 != _.findIndex(option.users.data,(z)=>{return z.id == e.id;});
            }), (e)=> {
                this.flag.users.push(e);
            });
        },
        canClearFlagFunc() {
            if(!this.flag) {
                return false;
            }
            let decodedConfig = JSON.parse(this.flag.flag_type.config);
            if(this.flag.creator.id && this.flag.creator.id != -1 && (!decodedConfig.permission_delete_only)){
                return true;
            }
            else if (_.filter(this.allDeleteRoles, (role) => {
                console.log("ROLE NAME", role.name);
                if(role.can_remove) {
                    return _.filter(role.users.data, (user) => {
                        return this.$store.getters.getProfile.id == user.id;
                    }).length > 0 || role.name == 'Read Only';
                }
                return false;
            }).length > 0) {
                return true;
            };
            return _.filter(this.allDeleteUsers, (user) => {
                return (this.$store.getters.getProfile.id == user.id && user.can_remove) || this.$store.getters.hasRole("Super Admin");
            }).length > 0;
        },
    },
    computed: {
        canUpdate () {
            return !(this.flag.users == null || this.flag.replies == null);
        },
        selectedFlag () {
            if (this.$store.getters.isFlagLoaded) {
                return this.$store.getters.activeFlag;
            } else {
                return null;
            }
        },
        _isFlagLoaded () {
            return this.$store.getters.isFlagLoaded;
        },
        isCleared () {
            return !this.flag || this.flag.cleared_at != null;
        },
        _clearedDate(){
            return this.formateTime(this.flag.cleared_at);
        },
        _createdDate(){
            return this.formateTime(this.flag.created_at);
        },
        _userTags(){
            return _.map(this.flag.users, function(user){ return user.name });
        },
        _roleTags(){
            return _.map(this.flag.roles, function(user){ return user.name });
        },
        _allTags(){
            return _.union(this._roleTags, this._userTags);
        },
        _displayUsers: function(){
            return _.filter(this.allUsers, (e)=>{return  -1 == _.findIndex(this.flag.users,(z)=>{return e.id == z.id}) && e.name.toLowerCase().includes(this.search.toLowerCase());});
        },
        _displayGroup: function(){
            return _.filter(this.allRoles, (e)=>{return e.name.toLowerCase().includes(this.search.toLowerCase());});
        },
        calander_followup_date: {
            get() {
                return this.calanderAttributes.followup_value;
            },
            set(value) {
                if(value) {
                    this.calanderAttributes.followup_display = moment(value).format('MM/DD/YYYY hh:mm a');
                    this.calanderAttributes.followup_value = value;
                } else {
                    this.calanderAttributes.followup_display = "";
                    this.calanderAttributes.followup_value = null;
                }
            }
        }
    },
    watch: {
        _isFlagLoaded: function (val) {
            (!val) ? this.close() : this.open();

        },
    }
};
</script>

<style>
    #edit-flag-modal .reportrange-text{
        height: 30px !important;
        width:170px !important;
    }
    /*removes thumb nail */
    #edit-flag-modal .daterangepicker::before{
        position:relative !important;
        top:0;
        border: 0;
        content: none;
    }
    #edit-flag-modal .daterangepicker:after {
        top:0;
    }
    /* positions to the right*/
    #edit-flag-modal .dropdown-menu{
        top: -100px !important;
        left: 343px !important;
        -webkit-transition: none !important;
        -moz-transition: none !important;
        -o-transition: none !important;
        transition: none !important;
    }
    #edit-flag-modal .reportrange-text {
        width: 100% !important;
    }
    #edit-flag-modal .set-height {
        height: 200px !important;
        width:90%;
        overflow: scroll !important;
    }
    #edit-flag-modal .w-100 {
        /*fixes other modal*/
        top: 0px !important;
        left: 0px !important;
    }
</style>
